var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "block-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.servcOrder.skuTitle != null
        ? _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("服务商品")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcOrder.skuTitle))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.servcOrder.reqVoucherId != null && _vm.servcOrder.reqVoucherId != -1
        ? _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("商品是否在保期")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              !_vm.servcOrder.beyondWrnt
                ? _c("label", { staticClass: "mr20" }, [_vm._v("是")])
                : _vm._e(),
              _vm._v(" "),
              _vm.servcOrder.beyondWrnt
                ? _c("label", { staticClass: "mr20" }, [_vm._v("否")])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title required" }, [_vm._v("紧急状态")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-select",
              {
                staticClass: "fl",
                attrs: { placeholder: "请选择", clearable: true },
                model: {
                  value: _vm.servcWorkVoucher.emgLevel,
                  callback: function($$v) {
                    _vm.$set(_vm.servcWorkVoucher, "emgLevel", $$v)
                  },
                  expression: "servcWorkVoucher.emgLevel"
                }
              },
              _vm._l(_vm.emgLevelList, function(emgLevel) {
                return _c("el-option", {
                  key: emgLevel.value,
                  attrs: { label: emgLevel.text, value: emgLevel.value }
                })
              })
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("服务名称")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.servcItem,
                  callback: function($$v) {
                    _vm.servcItem = $$v
                  },
                  expression: "servcItem"
                }
              },
              _vm._l(_vm.servcOrder.itemList, function(servcOrderItem, index) {
                return _c(
                  "el-radio",
                  {
                    attrs: {
                      disabled: servcOrderItem.isExists,
                      label: servcOrderItem
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(servcOrderItem.title))])]
                )
              })
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("故障描述")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm.servcOrder.troubleDesc != null
            ? _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcOrder.troubleDesc))
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("预约上门时间")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("label", { staticClass: "mr20" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcOrder.planTime))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("联系人")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm.servcOrder.retailerCom != null
            ? _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.servcOrder.retailerCom.contactName))
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("联系电话")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("label", { staticClass: "mr20" }, [
            _vm._v(_vm._s(_vm.servcOrder.buyerShopContactTel))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("请求服务地址")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("label", { staticClass: "mr20" }, [
            _vm._v(_vm._s(_vm.servcOrder.buyerShopAddr))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title" }, [_vm._v("请选择工程师")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            _vm._l(_vm.servcWorkVoucherStaffList, function(engineer, index) {
              return _c(
                "span",
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(engineer.engineerName) +
                      "\n                        "
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: engineer.engineerId },
                      model: {
                        value: _vm.checkValue,
                        callback: function($$v) {
                          _vm.checkValue = $$v
                        },
                        expression: "checkValue"
                      }
                    },
                    [_vm._v("是否主工程师  ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "font14 swb-btn-link",
                      on: {
                        click: function($event) {
                          _vm.removeEngineer(index)
                        }
                      }
                    },
                    [_vm._v("移除")]
                  )
                ],
                1
              )
            })
          ),
          _vm._v(" "),
          _c("label", { staticClass: "mr20" }, [
            _c(
              "a",
              {
                staticClass: "swb-btn-link",
                on: { click: _vm.engineerSelect }
              },
              [_vm._v("+ 选择工程师")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          { staticClass: "swb-btn mr20", on: { click: _vm.saveWorkVoucher } },
          [_vm._v("新建并派遣")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption bg-white dashed" }, [
      _c("div", { staticClass: "fl" }, [_c("span", [_vm._v("服务信息")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption bg-white dashed" }, [
      _c("span", [_vm._v("选择工程师")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a1f13fc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f13fc0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkVoucherAdd.vue
// module id = 2042
// module chunks = 1